var _linearGradient, _linearGradient2, _metadata, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "60mm",
    height: "60mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5988.68 5988.68",
    id: "svg12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient28231"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#696969",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop28227"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#696969",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop28229"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient28231",
    id: "linearGradient28225",
    x1: 2819.2388,
    y1: 1408.4785,
    x2: 3647.3357,
    y2: 1758.6814,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.1880121,0,0,1.1880121,-218.32085,-842.99125)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient28231",
    id: "linearGradient28483",
    gradientUnits: "userSpaceOnUse",
    x1: 2819.2388,
    y1: 1408.4785,
    x2: 3647.3357,
    y2: 1758.6814,
    gradientTransform: "matrix(-1.1880121,0,0,1.1880121,6808.039,-841.49175)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34927",
    style: {
      fill: "#ffa500",
      fillOpacity: 0.459657,
      stroke: "#1d1d1d",
      strokeWidth: 10.0024,
      strokeLinecap: "round",
      strokeLinejoin: "bevel"
    },
    d: "m 1136.5074,4134.6515 h 2371.8213 c 60.9955,0 110.1001,49.1046 110.1001,110.0999 v 1443.7008 c 0,60.9952 -49.1046,110.0998 -110.1001,110.0998 H 1136.5074 c -60.9954,0 -110.1001,-49.1046 -110.1001,-110.0998 V 4244.7514 c 0,-60.9953 49.1047,-110.0999 110.1001,-110.0999 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48349",
    transform: "matrix(0.94087035,0,0,0.94087035,-111.20649,354.10857)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 5988.6802,
    height: 5988.6802,
    id: "rect7",
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g11137"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect6264",
    style: {
      clipRule: "evenodd",
      fill: "#cd853f",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#020100",
      strokeWidth: 5.84987,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 2557.8744,2795.1689 c 0,0 225.2358,366.2205 765.5083,363.7945 561.3494,-2.5209 701.8427,-364.1332 701.8427,-364.1332 1230.7403,-256.1744 1354.8715,1581.4512 1170.9473,2427.4576 -198.111,170.476 -1102.0335,178.4774 -1102.0335,178.4774 l -34.7281,577.1433 C 2641.777,5947.5559 2750.6047,6001.5282 1521.8439,5844.802 1159.4333,5798.5771 1177.495,5436.4864 1218.8618,4933.8505 1302.4704,3917.9467 1898.0784,2513.6437 2557.8744,2795.1689 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      clipRule: "evenodd",
      fill: "#ffdead",
      fillRule: "evenodd",
      stroke: "#020100",
      strokeWidth: 6.13803,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 4120.5039,2339.738 c -215.1476,328.9931 -506.9503,513.8195 -811.2149,513.8195 -304.2648,0 -596.0675,-184.8264 -811.2151,-513.8195 -215.1477,-328.9933 -336.0161,-775.2037 -336.0161,-1240.4702 27.6874,-697.5335 511.8689,-1215.13574 1098.8698,-1228.67046 1274.7963,68.274034 1449.0902,1540.08316 859.5763,2469.14066 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect27629",
    style: {
      fill: "url(#linearGradient28225)",
      fillOpacity: 1,
      strokeWidth: 80.7561,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 3612.9364,1029.8638 h 313.6185 c 208.4541,45.3044 174.7985,48.3762 184.4356,315.6712 0,79.3551 -168.1898,201.2665 -190.4194,202.7477 l -307.6347,20.499 c -117.1238,7.8044 -211.8836,-94.5 -211.8836,-211.8835 v -115.1509 c 0,-117.3835 94.5001,-211.8835 211.8836,-211.8835 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect27629-6",
    style: {
      clipRule: "evenodd",
      fill: "url(#linearGradient28483)",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 80.7561,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 2976.7817,1031.3633 h -313.6184 c -208.4542,45.3044 -174.7985,48.3762 -184.4357,315.6712 0,79.3551 168.1899,201.2665 190.4195,202.7477 l 307.6346,20.499 c 117.1239,7.8044 211.8836,-94.5 211.8836,-211.8835 v -115.1509 c 0,-117.3835 -94.5,-211.8835 -211.8836,-211.8835 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect312",
    style: {
      color: "#000000",
      clipRule: "nonzero",
      fill: "#696969",
      fillRule: "nonzero",
      strokeWidth: 1.18801,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none",
      shapeRendering: "auto"
    },
    d: "m 2246.2772,932.00222 c -4.2113,0.0915 -8.4641,0.48764 -12.8067,1.28682 -34.7412,6.39374 -67.0999,34.24335 -101.2899,87.62516 a 19.304305,19.304305 0 0 0 5.8212,26.7165 19.304305,19.304305 0 0 0 26.6552,-5.8825 c 31.4277,-49.06882 57.1959,-67.04408 75.799,-70.46781 18.603,-3.4236 36.564,5.37137 57.8449,24.44929 21.2808,19.07792 43.3244,47.18162 66.3623,73.77672 21.959,25.3499 44.9829,49.1815 73.1027,62.747 -5.246,17.7808 -9.0264,36.1556 -5.5761,55.8227 l 34.0084,193.8173 c 16.4834,93.956 79.7605,153.4564 173.1058,173.1058 136.0522,28.6392 269.4082,69.6875 427.8932,12.8068 89.7835,-32.2236 141.9159,-86.9064 141.9159,-182.2973 v -187.3832 c 32.658,-26.7437 63.885,-37.2166 95.8364,-36.2756 26.1304,0.7696 53.2804,9.695 81.2524,24.8782 0,0.4749 -0.245,0.8722 -0.245,1.348 v 197.4326 c 0,95.3909 52.1327,150.0737 141.9162,182.2973 158.4852,56.8807 291.8408,15.8324 427.893,-12.8068 93.3453,-19.6494 156.6226,-79.1498 173.1059,-173.1058 l 34.0083,-193.8173 c 3.4504,-19.6671 -0.3301,-38.0419 -5.576,-55.8227 28.1201,-13.5655 51.1435,-37.3971 73.1028,-62.747 23.0379,-26.5951 45.0812,-54.6988 66.3622,-73.77672 21.2809,-19.07792 39.242,-27.87289 57.8449,-24.44929 18.6032,3.42373 44.3712,21.39899 75.799,70.46781 a 19.304305,19.304305 0 0 0 26.6553,5.8825 19.304305,19.304305 0 0 0 5.821,-26.7165 c -34.1899,-53.38181 -66.5485,-81.23142 -101.2897,-87.62516 -4.3427,-0.79918 -8.5954,-1.19533 -12.8066,-1.28682 -29.4795,-0.637 -55.6774,15.19216 -77.7599,34.98882 -25.2372,22.62476 -47.6925,51.69416 -69.7939,77.20826 -21.3666,24.6658 -42.475,44.9248 -61.1539,53.8006 -31.2144,-48.4446 -88.9009,-83.0295 -150.3108,-83.0295 h -430.7119 c -83.5317,0 -150.1957,60.7784 -166.3041,139.6489 -28.4935,-14.3588 -57.4437,-23.2758 -86.8899,-24.1429 -34.3779,-1.0125 -68.7347,9.968 -101.7801,32.7828 -12.5463,-83.1733 -81.4855,-148.2888 -168.0811,-148.2888 h -430.712 c -61.4102,0 -119.0963,34.5849 -150.311,83.0295 -18.6785,-8.8758 -39.7872,-29.1348 -61.1538,-53.8006 -22.1014,-25.5141 -44.5566,-54.5835 -69.7939,-77.20826 -22.0825,-19.79666 -48.2804,-35.62582 -77.7597,-34.98882 z m 359.0184,143.08038 h 430.712 c 63.1247,0 112.9936,49.8685 112.9936,112.9935 v 197.4326 c 0,63.1251 -36.8962,117.2051 -98.41,131.3766 -108.4431,24.9828 -157.8966,56.1234 -411.2872,-21.9983 -60.3233,-18.5981 -102.0857,-50.8181 -112.9936,-112.9936 l -34.0084,-193.8173 c -10.908,-62.1755 49.8684,-112.9935 112.9936,-112.9935 z m 953.7672,0 h 430.7119 c 63.1251,0 123.9016,50.818 112.9936,112.9935 l -34.0086,193.8173 c -10.9079,62.1755 -52.6701,94.3955 -112.9936,112.9936 -253.3907,78.1217 -302.8438,46.9811 -411.287,21.9983 -61.5137,-14.1715 -98.4099,-68.2515 -98.4099,-131.3766 v -197.4326 c 0,-63.125 49.8685,-112.9935 112.9936,-112.9935 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1d1d1d",
      strokeWidth: 254.125,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 2659.501,33.829266 c 88.7042,-134.494266 235.2935,-229.356256 394.323,-255.177386 159.0296,-25.82113 328.102,17.78789 454.8023,117.30762 76.3941,60.005553 139.1647,139.875703 227.4161,180.476376 71.3825,32.840034 155.8015,36.200804 229.5688,9.139284 73.7672,-27.061523 135.9861,-84.2164007 169.1977,-155.426806",
    id: "path29715"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#1d1d1d",
      strokeWidth: 222.916,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 2723.1976,293.26781 c 77.8105,-117.97711 206.3972,-201.18917 345.8965,-223.839231 139.4993,-22.650061 287.808,15.603343 398.9483,102.901101 67.0122,52.6363 122.074,122.69763 199.4873,158.31216 62.6161,28.80697 136.6677,31.75501 201.3756,8.0169 64.708,-23.73811 119.2858,-73.87382 148.4187,-136.33892",
    id: "path29715-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 11.8577,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 2017.9315,4404.4418 -61.939,710.1329 2133.1849,277.9956",
    id: "path31930"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 11.8577,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 4089.1774,5392.5703 -29.7663,585.3382",
    id: "path32330"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2f4f4f",
      strokeWidth: 173.716,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 4373.0797,2766.7679 c -50.4658,1039.5813 -285.8856,1747.794 -504.9934,2418.9903",
    id: "path40181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g48263",
    transform: "matrix(1.1880121,0,0,1.1880121,-406.56195,-905.73838)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 3038.1057,5388.549 c 197.8594,-95.3166 55.2808,-77.4179 109.0006,-252.0001 256.9622,84.6047 199.8028,-25.4725 527.5474,77.2318 299.1563,93.7371 617.1792,63.6826 731.5327,431.1517 14.0587,45.1781 -13.8069,143.1765 -141.6515,125.1083 -318.5003,-45.0246 -814.2184,-68.7275 -921.5592,-26.7143",
    fill: "#57331f",
    id: "path18",
    style: {
      fill: "#ffdead",
      fillOpacity: 1,
      strokeWidth: 126.216
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5.64785,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 4274.6686,5418.0493 -453.4559,-20.9572",
    id: "path47980"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 5.82108,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "M 4346.8076,5526.4955 3864.2799,5505.574",
    id: "path47980-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 4.99057,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 4398.3634,5645.9875 -351.7653,-21.0936",
    id: "path47980-6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect6264-6",
    style: {
      clipRule: "evenodd",
      fill: "#2f4f4f",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#020100",
      strokeWidth: 5.84988,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    d: "m 1546.3847,3641.1741 c -401.5289,811.8009 -610.19125,2251.0375 6.6378,2293.6666 1199.5735,82.9026 1717.541,14.4044 3008.3649,41.3 43.2735,-3.1248 95.3033,-40.5669 78.0049,-81.1297 C 3731.1105,4785.393 3329.1485,4905.6627 1880.9222,4687.3867 1617.8899,4647.7426 1904.0629,3695.162 1546.3847,3641.1741 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.ee9d23d3e60b6c84f6f52b955d9cee39.svg";
export { ForwardRef as ReactComponent };